import { type ComponentPropsWithoutRef } from "react";
import { twMerge } from "tailwind-merge";

// https://ionic.io/ionicons type in input today -> in outline section
const TodayOutlineIcon = ({
  className,
  ...props
}: ComponentPropsWithoutRef<"svg">) => {
  const defaultClassnames =
    "icon icon-ionicons icon-ionicons-today-outline h-2.75 w-2.75";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={twMerge(defaultClassnames, className)}
      viewBox="0 0 512 512"
      stroke="currentColor"
      fill="currentColor"
      {...props}
    >
      <rect
        fill="none"
        strokeLinejoin="round"
        strokeWidth="32"
        x="48"
        y="80"
        width="416"
        height="384"
        rx="48"
      />
      <path
        fill="none"
        strokeLinejoin="round"
        strokeWidth="32"
        strokeLinecap="round"
        d="M128 48v32M384 48v32"
      />
      <rect
        fill="none"
        strokeLinejoin="round"
        strokeWidth="32"
        strokeLinecap="round"
        x="112"
        y="224"
        width="96"
        height="96"
        rx="13"
      />
      <path
        fill="none"
        strokeLinejoin="round"
        strokeWidth="32"
        strokeLinecap="round"
        d="M464 160H48"
      />
    </svg>
  );
};

export default TodayOutlineIcon;
